import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useFormContext, Controller } from 'react-hook-form';
import clsx from 'clsx';
import moment from 'moment';
import { mask } from 'remask';

import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  CircularProgress,
  Button,
  TextField,
  Typography,
  Icon,
  Backdrop,
  Dialog,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import InputMask from 'react-input-mask';

import { instanceAxios } from '../../../InstanceAxios';

import { unmaskCepPattern } from '../../../utils/patterns';

import { requestMessageError, formatFinalValue } from '../helpers';
import { XMEI_PRIMARY_COLOR } from '../../../consts/common';
import ModalJustificationData from '../components/ModalJustificationData';
import user from 'src/store/modules/user';

const useStyles = makeStyles((theme) => ({
  root: {},
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '15px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
  formControl: {
    margin: '6px 0',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  group: {},
  formGroupTitle: {
    position: 'absolute',
    top: -10,
    left: 8,
    fontWeight: 600,
    padding: '0 4px',
    backgroundColor: theme.palette.background.paper,
  },
  formGroup: {
    position: 'relative',
    border: '1px solid ',
    borderRadius: 2,
    padding: '12px 12px 0 12px',
    margin: '24px 0 16px 0',
    '&:first-of-type': {
      marginTop: 16,
    },
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
    backgroundColor: XMEI_PRIMARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: '#8d8d8e',
    },
  },
  cssFocused: {},
  loadingCard: {
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeInOut,
  },
  search: {
    margin: theme.spacing(2, 0, 2),
    backgroundColor: XMEI_PRIMARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
  },
  mr16: {
    marginRight: '1.6em',
  },
  textContent: { fontSize: 18, color: '#202020', fontWeight: 'bold' },
  label: { fontSize: 15, color: '#ACABB9' },
  viewRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
  },
  viewColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 10,
  },
  viewValue: { marginLeft: '5%' },
  marginBottom: { marginBottom: 10 },
  titleBankSlip: { alignItems: 'center', marginVertical: 20 },
}));

function FormBoleto(props) {
  const classes = useStyles(props);
  const [nomeServico, setNomeServico] = useState('');
  const [cupomObj, setCupomObj] = useState(null);
  const [valorServico, setValorServico] = useState('');
  const [bankSlipResponse, setBankSlipResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    text: '',
    icon: '',
    color: '',
  });

  const methods = useFormContext();
  const { control, formState, getValues, setValue } = methods;
  const { errors } = formState;

  const { nome, cpf, email } = props.state.user;

  const [open, setOpen] = useState(false);

  async function handleGetAddress() {
    setLoading(true);
    const cep = getValues('cep');
    await axios
      .get(`https://viacep.com.br/ws/${mask(cep, unmaskCepPattern)}/json/`)
      .then((res) => {
        if (!res.data || res.data.erro) {
          setLoading(false);
          return;
        }
        setValue('logradouro', res.data.logradouro);
        setValue('complemento', res.data.complemento);
        setValue('bairro', res.data.bairro);
        setValue('cidade', res.data.localidade);
        setValue('estado', res.data.uf);
        setValue('cep', cep);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setNomeServico(props.state.item.nome);
    setValorServico(props.state.item.valor);
  }, [nomeServico, valorServico]);

  const bankSlip = async (objAddress) => {
    const objItem = {
      description: `Imobitech Go - ${nomeServico}`,
      quantity: 1,
      price_cents: parseFloat(valorServico).toFixed(2) * 100,
    };
    const instance = instanceAxios();

    const request_body = {
      method: 'bank_slip',
      email,
      cpf_cnpj: cpf,
      items: [objItem],
      zip_code: objAddress.cep,
      number: objAddress.numero,
      usuario: user,
    };

    if (cupomObj) {
      request_body.cupom = cupomObj;
    }

    await instance
      .post('/realizarCobrancaDireta', {
        ...request_body,
      })
      .then(async (res) => {
        const fatura = await instance.get(
          `/buscarFatura/${res.data.boleto.invoice_id}`
        );
        const split_due_date = fatura.data.fatura.due_date.split('-');
        res.data.boleto.due_date = `${split_due_date[2]}/${split_due_date[1]}/${split_due_date[0]}`;
        setBankSlipResponse(res.data.boleto);
        setLoading(false);
      })
      .catch(async (err) => {
        setMessage({
          text: `ERROR: ${requestMessageError(err)}`,
          icon: 'remove_circle_outline',
          color: 'red',
        });
        setLoading(false);
      });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const data = getValues();

    bankSlip(data);
  };

  return (
    <div className={classes.root}>
      {/* Show modal for info view */}
      <div>
        <Dialog
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <DialogContent dividers="paper">
            <ModalJustificationData />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* Item object table */}
      <Card>
        <CardContent>
          <div className={classes.titleBankSlip}>
            <Typography className={classes.textContent}>
              DETALHES DO BOLETO
            </Typography>
          </div>
          <div className={classes.marginBottom}>
            <Typography className={classes.label}>Descrição Serviço</Typography>
            <Typography className={classes.textContent}>
              {nomeServico}
            </Typography>
          </div>
          <div className={classes.marginBottom}>
            <Typography className={classes.label}>Pagador</Typography>
            <Typography className={classes.textContent}>{nome}</Typography>
          </div>
          <div className={classes.viewRow}>
            <div>
              <Typography className={classes.label}>Emissão</Typography>
              <Typography className={classes.textContent}>
                {moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY')}
              </Typography>
            </div>
            <div className={classes.viewValue}>
              <Typography className={classes.label}>Valor</Typography>
              <Typography className={classes.textContent}>
                {cupomObj
                  ? formatFinalValue({
                      cupomObj,
                      setCupomObj,
                      referCodeObj: null,
                      valor: valorServico,
                    })
                  : `R$ ${parseFloat(valorServico).toFixed(2)}`}
              </Typography>
            </div>
          </div>
          {bankSlipResponse && (
            <div className={classes.viewColumn}>
              <div>
                <Typography className={classes.label}>Vencimento</Typography>
                <Typography className={classes.textContent}>
                  {bankSlipResponse.due_date}
                </Typography>
              </div>
              <div>
                <Typography className={classes.label}>
                  Código de barras
                </Typography>
                <Typography className={classes.textContent}>
                  {bankSlipResponse.identification}
                </Typography>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
      {!bankSlipResponse && (
        <>
          <div className={classes.titleBankSlip}>
            <Typography className={classes.textContent}>
              COMPLETE OS SEUS DADOS
            </Typography>
          </div>
          <Controller
            control={control}
            name="cep"
            defaultValue=""
            render={({ field: { onChange, onBlur, ref, value } }) => (
              <InputMask
                mask="99.999-999"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
              >
                {(inputProps = ref) => (
                  <TextField
                    name="cep"
                    placeholder="digite o cep..."
                    error={!!errors?.cep}
                    helperText={errors?.cep ? errors.cep.message : ''}
                    required
                    label="CEP"
                    autoFocus
                    id="cep"
                    variant="outlined"
                    {...inputProps}
                    className={classes.mr16}
                  />
                )}
              </InputMask>
            )}
          />
          {/* <Input
                className="p-16"
                name="cep"
                classes={{ root: 'text-14' }}
                placeholder="digite o cep..."
                margin="none"
                onChange={(evt) => {
                    setCep(evt.target.value);
                }}
            /> */}
          <Button
            variant="contained"
            color="primary"
            aria-label="post"
            onClick={handleGetAddress}
            className={classes.search}
          >
            Buscar endereço
          </Button>

          {loading ? (
            <div
              role="button"
              className={clsx(
                classes.loadingCard,
                'flex items-center justify-center relative w-128 h-128 rounded-16 mx-12 mb-24 overflow-hidden cursor-pointer outline-none '
              )}
            >
              <CircularProgress color="primary" size={25} />
            </div>
          ) : (
            <div />
          )}
          {message.text !== '' && (
            <Typography
              className={`text-${message.color} text-16 sm:text-20 truncate mr-32`}
            >
              {message.text} <Icon className="text-20">{message.icon}</Icon>
            </Typography>
          )}

          <Controller
            name="logradouro"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                className={classes.mr16}
                error={!!errors?.logradouro}
                helperText={errors?.logradouro ? errors.logradouro.message : ''}
                label="Logradouro "
                id="logradouro"
                style={{ width: '49%' }}
                InputLabelProps={{ style: { fontSize: 16 }, shrink: true }}
                variant="outlined"
                autoFocus
              />
            )}
          />

          <Controller
            control={control}
            name="numero"
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                error={!!errors?.numero}
                helperText={errors?.numero ? errors.numero.message : ''}
                style={{ width: '48.8%' }}
                label="Número"
                autoFocus
                id="numero"
                variant="outlined"
                fullWidth
                required
                type="number"
              />
            )}
          />

          <Controller
            name="complemento"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                className={classes.mr16}
                label="Complemento"
                id="complemento"
                style={{ width: '49%' }}
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: 16 },
                }}
                InputProps={{
                  style: { fontSize: 16 },
                }}
                variant="outlined"
              />
            )}
          />

          <Controller
            name="bairro"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Bairro"
                error={!!errors?.bairro}
                helperText={errors?.bairro ? errors.bairro.message : ''}
                InputProps={{
                  style: { fontSize: 16 },
                }}
                style={{ width: '48.8%' }}
                InputLabelProps={{ style: { fontSize: 16 }, shrink: true }}
                id="bairro"
                variant="outlined"
              />
            )}
          />

          <Controller
            name="cidade"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                className={classes.mr16}
                error={!!errors?.cidade}
                helperText={errors?.cidade ? errors.cidade.message : ''}
                label="Cidade"
                InputProps={{
                  style: { fontSize: 16 },
                }}
                style={{ width: '49%' }}
                InputLabelProps={{ style: { fontSize: 16 }, shrink: true }}
                id="cidade"
                variant="outlined"
              />
            )}
          />

          <Controller
            name="estado"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                error={!!errors?.estado}
                helperText={errors?.estado ? errors.estado.message : ''}
                label="Estado"
                InputProps={{
                  style: { fontSize: 16 },
                }}
                style={{ width: '48.8%' }}
                InputLabelProps={{ style: { fontSize: 16 }, shrink: true }}
                id="estado"
                variant="outlined"
              />
            )}
          />
          <Button
            type="button"
            variant="contained"
            fullWidth
            // disabled={!isValid}
            className={classes.submit}
            onClick={handleSubmit}
          >
            {loading ? (
              <CircularProgress color="primary" size={25} />
            ) : (
              'GERAR BOLETO'
            )}
          </Button>

          {message.text !== '' && (
            <Typography style={{ color: 'red' }}>
              {message.text} <Icon className="text-20">{message.icon}</Icon>
            </Typography>
          )}
        </>
      )}
    </div>
  );
}

export default FormBoleto;
